import { render, staticRenderFns } from "./HousingAuth.vue?vue&type=template&id=87353dce"
import script from "./HousingAuth.vue?vue&type=script&lang=js"
export * from "./HousingAuth.vue?vue&type=script&lang=js"
import style0 from "./HousingAuth.vue?vue&type=style&index=0&id=87353dce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports